import styled from 'styled-components'
import { Tonality } from '@dsny/dsny-component-library'
import {
  LEGACY_BREAKPOINT_QUERIES,
  createResponsiveBreakpointQuery
} from 'styles/breakpoints'

const tabletQuery = createResponsiveBreakpointQuery('tabletUp', {
  legacyQuery: LEGACY_BREAKPOINT_QUERIES.tabletUp
})

export const StyledTabPanel = styled(Tonality.TabPanel)`
  border-radius: 5px;
  min-height: 80px;
  padding-top: 64px;
`

export const AccountContainer = styled.div`
  margin: 0 auto;
  padding: 0 16px 8px;
  font-family: ${({ theme }) => theme.fonts.primary};

  ${StyledTabPanel} {
    color: ${({ theme }) => theme.colors.neutralW80};
  }

  @media ${tabletQuery} {
    padding: 0 64px 8px;
  }
`
